import React from 'react';
import HeaderCell from './header-cell'
import { oneDecimal } from '../../helpers/formatters'
import styles from './region-entity-table.module.scss';

export const RegionTableHeader = ({ region, comparing, isMobile, isStandalone }) => {
    return (
        <tr>
            <td colSpan={isMobile ? 1 : 2}>
                <div>
                    <div>
                        <span className={styles.tableHeaderText}>{comparing ? region.name : 'In this region'}</span>
                    </div>
                    {!comparing && !isMobile &&
                        <div>
                            <span className={styles.cellInfoText}>Click on an organisation for more details about its finances</span>
                        </div>
                    }
                </div>
            </td>
            <td><HeaderCell label={isStandalone ? "campuses" : "campuses**"} value={region.numCampuses} /></td>
            <td><HeaderCell label={"schools"} value={region.numSchools} /></td>
            <td><HeaderCell label={"students"} value={oneDecimal(region.numStudents)} /></td>
            <td><HeaderCell label={"staff (fte)"} value={oneDecimal(region.numEmployees)} /></td>
        </tr>
    )
}


// WEBPACK FOOTER //
// ./src/components/region-entity-table/region-table-header.js